import { render, staticRenderFns } from "./MainPeopleAtCompanyCard.vue?vue&type=template&id=270042ae&scoped=true&"
import script from "./MainPeopleAtCompanyCard.vue?vue&type=script&lang=js&"
export * from "./MainPeopleAtCompanyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270042ae",
  null
  
)

export default component.exports